import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type WechatPayProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const WechatPay = ({ size = 24, width, height, alt = '', style, ...props }: WechatPayProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-1.811631 -1.009551) scale(1.11895)',
        },
        [
          h(
            'path',
            {
              d: 'M9.48071 14.0828C9.38598 14.1307 9.27908 14.1583 9.16554 14.1583C8.90311 14.1583 8.67488 14.0137 8.55511 13.8002L8.50918 13.6995L6.59748 9.50482C6.57686 9.45901 6.56396 9.40762 6.56396 9.35752C6.56396 9.16411 6.72066 9.00726 6.91407 9.00726C6.99262 9.00726 7.06505 9.03323 7.12364 9.07679L9.37933 10.6828C9.54427 10.7908 9.74106 10.854 9.95271 10.854C10.0793 10.854 10.1996 10.8305 10.312 10.7895L20.9208 6.06779C19.0194 3.82672 15.8875 2.36194 12.3433 2.36194C6.54371 2.36194 1.84247 6.27971 1.84247 11.1126C1.84247 13.7496 3.25701 16.123 5.4708 17.727C5.64852 17.8537 5.76465 18.062 5.76465 18.2971C5.76465 18.3748 5.74796 18.4462 5.72786 18.5201C5.55103 19.1799 5.26787 20.2358 5.25468 20.2853C5.23264 20.368 5.19806 20.4546 5.19806 20.5412C5.19806 20.7345 5.35491 20.8912 5.54832 20.8912C5.62451 20.8912 5.68637 20.863 5.75057 20.8261L8.04946 19.499C8.22236 19.399 8.40545 19.3373 8.60706 19.3373C8.71434 19.3373 8.81807 19.3538 8.91582 19.3837C9.98821 19.6921 11.1453 19.8636 12.3433 19.8636C18.1427 19.8636 22.8443 15.9457 22.8443 11.1126C22.8443 9.64894 22.4107 8.27026 21.6482 7.05774L9.55729 14.0385L9.48071 14.0828Z',
              fill: '#00C800',
            },
          ),
        ],
      ),
    ],
  );

export default WechatPay;
